import { Box, Card, Divider, ListItemText, Stack } from '@mui/material'
import { memo } from 'react'

import { LOYALIZE_API } from '../../constants/api'
import { Image } from '../shared/image'
import { Label } from '../shared/label'
import SubmitButton from '../shared/button/SubmitButton'
import {
  CASHBACK_PER_VALUE,
  displayCashbackValue
} from '../../util/cashback.helpers'
import { formatTicks } from '../../util/string.helpers'

const CashbackBrandCard = ({
  t,
  id,
  name,
  description,
  commission,
  imageUrl,
  trackingUrl,
  onCashbackShopNowClick,
  cashbackCurrency,
  tokenProfile: { onramp, symbol }
}) => {
  const { value, currency, label } = displayCashbackValue(commission, {
    onramp,
    cashbackCurrency
  })
  return (
    id && (
      <Card>
        <Box sx={{ p: 3, pb: 2 }}>
          <Image
            src={imageUrl || `${LOYALIZE_API}${id}/logo`}
            slotProps={{
              img: {
                loading: 'lazy',
                sx: {
                  objectFit: 'contain'
                }
              }
            }}
            sx={{
              borderRadius: 2,
              width: 160,
              height: 90,
              mb: 2,
              backgroundColor: 'common.white',
              p: 1.5
            }}
            visibleByDefault={false}
          />

          <ListItemText
            sx={{ mb: 1 }}
            primary={name}
            secondary={description}
            slotProps={{
              primary: { sx: { typography: 'subtitle1' } },
              secondary: {
                sx: {
                  mt: 1,
                  typography: 'caption',
                  color: 'text.disabled',
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }
              }
            }}
          />

          <Label color='primary' sx={{ width: 'fit-content' }}>
            {t(label, {
              count: CASHBACK_PER_VALUE,
              symbol,
              value: formatTicks(value),
              currency
            })}
          </Label>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <Stack
          sx={{
            p: 3,
            alignItems: 'flex-end'
          }}
        >
          <SubmitButton
            label={t('cashback.shop-now')}
            onClick={() => onCashbackShopNowClick(trackingUrl)}
            type='button'
          />
        </Stack>
      </Card>
    )
  )
}

export default memo(CashbackBrandCard)
